import { ListBranchModel } from '../types-store';

export const compareModel = (model1: ListBranchModel, model2: ListBranchModel): boolean =>
  model1?.subscriberGroup === model2?.subscriberGroup;
